import React, { useEffect, useState } from "react";
import "./user.css";
import { useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";

/** Shared header (Extramile Play logo + Back button) wrapping every player-facing Modak Marathon screen. */
function USER({ children }) {
  const location = useLocation();

  const { companyLogoUrl, backButtonUrl } = useSelector(state => state.ui);
  const [logoUrl, setLogoUrl] = useState("");
  const [backUrl, setBackUrl] = useState("");

  const { user } = useSelector(state => state.auth);
  const fromMobileAppInUrl =
    String(new URLSearchParams(location.search).get("fromMobileApp") || "").toLowerCase() ===
    "true";
  const fromMobileAppInUser = String(user?.fromMobileApp || "").toLowerCase() === "true";
  const persistedFromMobileApp = (() => {
    try {
      const persisted = JSON.parse(
        sessionStorage.getItem("userData") || "{}"
      );
      return String(persisted?.fromMobileApp || "").toLowerCase() === "true";
    } catch {
      return false;
    }
  })();
  const isFromMobileApp = fromMobileAppInUrl || fromMobileAppInUser || persistedFromMobileApp;

  useEffect(() => {
    setBackUrl(backButtonUrl);
    setLogoUrl(companyLogoUrl);
  }, [backButtonUrl, companyLogoUrl]);

  useEffect(() => {
    document.title = "Modak Marathon";
  }, []);

  const handleLogoClick = (e) => {
    if (!isFromMobileApp) return;
    e.preventDefault();
    window.GameStatus?.postMessage?.("navigate_back");
  };

  return (
    <div className="ii-game-shell">
      <header className="upperaction">
        <a href={process.env.REACT_APP_BASE_URL} onClick={handleLogoClick}>
          <img src={logoUrl} className="logo-holder" alt="Extramile Play" />
        </a>
        {!isFromMobileApp && (
          <div className="back-holder">
            <a href={backUrl}>
              <button type="button" className="back-default">
                Back
              </button>
            </a>
          </div>
        )}
      </header>
      {children}
    </div>
  );
}

export default USER;
